export enum FloorTypes {
  NONE = 'NONE',
  ANTISLIP = 'ANTISLIP',
  DURAFLOOR = 'DURAFLOOR',
  REINFORCEDANTISLIP = 'REINFORCEDANTISLIP',
  ALUMINUM25 = 'ALUMINUM25',
  ALUMINUM35 = 'ALUMINUM35',
  STEELSMOOTH3 = 'STEELSMOOTH3',
  STEELANTISLIP5 = 'STEELANTISLIP5',
  RVSANTISLIPR13 = 'RVSANTISLIPR13',
}
